interface CardItem {
  image: string;
  imageAlt: string;
  tag: string;
  title: string;
  desc: string;
  views: string;
  time: string;
}

const cards: CardItem[] = [
  {
    image: "https://readdy.ai/api/search-image?query=Entertainment%20news%20studio%20setting%20with%20microphone%20and%20warm%20spotlight%2C%20professional%20broadcast%20equipment%2C%20dark%20background%20with%20soft%20amber%20lighting%2C%20editorial%20photography%20style%2C%20clean%20composition&width=600&height=400&seq=card-01-91cg&orientation=landscape",
    imageAlt: "娱乐爆料现场",
    tag: "娱乐圈",
    title: "顶流明星疑似恋情曝光，双方工作室紧急回应",
    desc: "当红一线明星被拍到深夜同返住所，粉丝热议不断，工作室连夜发布声明。",
    views: "256.3万",
    time: "2小时前",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Social%20media%20live%20streaming%20scene%20with%20smartphone%20on%20tripod%2C%20colorful%20ring%20light%2C%20modern%20room%20background%2C%20warm%20ambient%20lighting%2C%20editorial%20style%2C%20clean%20aesthetic&width=600&height=400&seq=card-02-91cg&orientation=landscape",
    imageAlt: "网红直播场景",
    tag: "网红圈",
    title: "知名带货主播涉嫌虚假宣传，消费者集体维权",
    desc: "百万粉丝主播直播间夸大产品功效，多地消费者协会已介入调查取证。",
    views: "189.7万",
    time: "5小时前",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Reality%20TV%20show%20stage%20with%20colorful%20lights%20and%20empty%20judges%20chairs%2C%20dramatic%20spotlight%20effects%2C%20dark%20atmosphere%2C%20television%20production%20set%2C%20editorial%20photography%2C%20warm%20tone&width=600&height=400&seq=card-03-91cg&orientation=landscape",
    imageAlt: "综艺节目舞台",
    tag: "综艺圈",
    title: "热门综艺录制现场冲突，两位导师当场翻脸",
    desc: "某选秀节目录制中导师意见严重分歧，节目组被迫中断录制进行调解。",
    views: "212.5万",
    time: "8小时前",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Social%20controversy%20news%20scene%2C%20crowd%20gathered%20with%20smartphones%20recording%2C%20urban%20street%20setting%2C%20dramatic%20warm%20evening%20lighting%2C%20documentary%20photography%20style%2C%20natural%20composition&width=600&height=400&seq=card-04-91cg&orientation=landscape",
    imageAlt: "社会热点现场",
    tag: "社会圈",
    title: "街头偶遇名人私密聚餐，同行对象身份引发猜测",
    desc: "路人实拍两位话题人物餐厅密会，举止亲密引网友疯狂讨论双方关系。",
    views: "178.2万",
    time: "12小时前",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Film%20set%20behind%20scenes%20with%20camera%20equipment%20and%20director%20chair%2C%20movie%20production%20atmosphere%2C%20warm%20cinematic%20lighting%2C%20professional%20filmmaking%20scene%2C%20editorial%20style%2C%20clean%20composition&width=600&height=400&seq=card-05-91cg&orientation=landscape",
    imageAlt: "影视剧拍摄现场",
    tag: "影视圈",
    title: "年度大制作换角风波，原定主演与导演矛盾升级",
    desc: "投资过亿的古装剧开机前临时更换男主角，知情人士透露幕后复杂原因。",
    views: "145.9万",
    time: "1天前",
  },
  {
    image: "https://readdy.ai/api/search-image?query=International%20entertainment%20news%20collage%20with%20headlines%20and%20social%20media%20icons%2C%20global%20gossip%20theme%2C%20warm%20dark%20background%2C%20modern%20editorial%20design%2C%20clean%20composition&width=600&height=400&seq=card-06-91cg&orientation=landscape",
    imageAlt: "海外娱乐资讯",
    tag: "海外圈",
    title: "国际巨星被曝税务问题，全球媒体争相报道",
    desc: "欧美顶流艺人深陷财务丑闻，多国税务部门已启动联合调查程序。",
    views: "132.4万",
    time: "1天前",
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-2">精选推荐</h2>
        <p className="text-foreground-500 text-sm text-center mb-10">编辑精选吃瓜内容，每日人工甄选优质视频</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <a
              key={card.title}
              href="#cards"
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/50 transition-colors duration-200 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500/90 text-white text-xs font-medium whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {card.desc}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                  <span>{card.time}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}